import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import VideoGrid from './components/VideoGrid';
import FeaturesSection from './components/FeaturesSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <SEOHead
        title="91免费视频-海量免费视频在线观看平台"
        description="91免费视频为您提供海量高清视频资源，无需注册即可免费在线观看。涵盖多种类型视频内容，支持手机、平板、电脑多端流畅播放，随时随地享受优质免费视频体验。"
        keywords="91免费视频,免费视频在线观看,高清免费视频,91视频免费播放,免费视频网站,在线免费视频平台,手机免费视频"
        canonicalUrl={`${window.location.origin}${__BASE_PATH__}/`}
        ogTitle="91免费视频 - 海量免费视频在线观看平台"
        ogDescription="海量高清视频资源，无需注册即可免费在线观看。涵盖多种类型视频内容，随时随地享受优质免费视频体验。"
        ogImage="https://readdy.ai/api/search-image?query=Modern%20video%20streaming%20platform%20interface%20with%20colorful%20video%20thumbnails%2C%20clean%20dark%20theme%2C%20entertainment%20website%20design%2C%20movie%20posters%20grid%2C%20digital%20media%20platform%2C%20warm%20accent%20colors&width=1200&height=630&seq=og-homepage&orientation=landscape"
        schemaData={{
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: '91免费视频',
          url: `${window.location.origin}${__BASE_PATH__}/`,
          description: '91免费视频为您提供海量高清视频资源，无需注册即可免费在线观看。',
          potentialAction: {
            '@type': 'SearchAction',
            target: `${window.location.origin}${__BASE_PATH__}/search?q={search_term_string}`,
            'query-input': 'required name=search_term_string',
          },
        }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryGrid />
          <VideoGrid />
          <FeaturesSection />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}